export const CREATE_DOCTOR_OFFICE_IMAGE_REQUEST = "CREATE_DOCTOR_OFFICE_IMAGE_REQUEST";
export const DELETE_DOCTOR_OFFICE_IMAGE_REQUEST = "DELETE_DOCTOR_OFFICE_IMAGE_REQUEST";
